<div
	*ngIf="isUkgcLoginMessageVisible$ | async"
	[innerHTML]="'ukgc.asa.message' | translate"
	class="ukgc-login-message"
></div>
<form (ngSubmit)="login()" [formGroup]="formGroup" test-id="login-form" data-test-id="login-form">
	<div class="obg-m-generic-login-content">
		<mat-form-field>
			<input
				matInput
				#username
				type="email"
				formControlName="username"
				test-id="login-username"
				id="login-username"
				data-test-id="login-username"
				placeholder="{{ 'login.username.placeholder' | translate }}"
				(blur)="gtmEventAction('Email')"
			/>
		</mat-form-field>
		<mat-form-field>
			<input
				matInput
				type="password"
				formControlName="password"
				test-id="login-password"
				id="login-password"
				data-test-id="login-password"
				#pass
				placeholder="{{ 'login.password.placeholder' | translate }}"
				(blur)="gtmEventAction('Password')"
			/>
			<mat-icon
				class="obg-m-password-toggle"
				matSuffix
				[obgTogglePasswordFor]="pass"
				passClass="ico-hide"
				textClass="ico-show"
				test-id="show-password-icon"
				data-test-id="show-password-icon"
			></mat-icon>
		</mat-form-field>
	</div>
	<div class="obg-m-generic-login-actions">
		<div class="extra-actions">
			<mat-slide-toggle
				*ngIf="(isRememberMeAllowed$ | async) && formGroup.controls.shouldRememberUser"
				formControlName="shouldRememberUser"
				test-id="login-should-remember-user"
				color="primary"
				(change)="gtmEventAction('RememberMe')"
				>{{ 'login.rememberEmail.placeholder' | translate }}
			</mat-slide-toggle>
			<a
				[obgRouteLinkOptions]="{ state: { username: formGroup.value.username } }"
				[obgRouteLink]="forgotPasswordRoute"
				(click)="forgotPasswordClick.emit()"
				[obgInteraction]="forgotPasswordTrackingData"
				[target]="allLinksExternal ? '_blank' : null"
				test-id="login-forgot-password"
				data-test-id="login-forgot-password"
				>{{ 'login.forgot-password' | translate }}</a
			>
		</div>
		<div
			*ngIf="error"
			class="validation-error"
			[attr.test-id]="error | jurisdiction | kebabcase"
			[attr.data-test-id]="error | jurisdiction | kebabcase"
		>
			<ng-container *ngIf="isErrorRelatedToTwoFactorAuth; else regularError">
				<obg-m-customer-service-link [messageKey]="error" (customerSupportClick)="customerSupportOnClick(true)">
				</obg-m-customer-service-link>
			</ng-container>
			<ng-template #regularError>
				{{ error | jurisdiction | translate }}
				<div *ngIf="customerCanLogInAt">
					<div [ngSwitch]="jurisdiction">
						<strong *ngSwitchCase="'Ksa'">{{ customerCanLogInAt }}</strong>
						<label *ngSwitchCase="'Hgc'"></label>
						<label *ngSwitchDefault>{{ customerCanLogInAt }}</label>
					</div>
				</div>
			</ng-template>
		</div>

		<button
			#submitButton
			mat-flat-button
			class="obg-m-generic-login-button"
			color="accent"
			test-id="login-submit"
			data-test-id="login-submit"
		>
			{{ 'login.submit' | translate }}
		</button>

		<obg-social-login-container *ngIf="isGoogleLoginEnabled$ | async"></obg-social-login-container>
	</div>
</form>
